import { useAtom } from "jotai";
import { PropsWithChildren, useEffect } from "react";
import mixpanel from "../../common/mixpanel-config";
import { useCurrentUserSubscriptionTier } from "../../hooks/use-current-user-subscription-tier/use-current-user-subscription-tier";
import { useIsLogged } from "../../hooks/use-is-logged/use-is-logged";
import { useAbility } from "../../hooks/useAbilityRules";
import { useAccount } from "../../hooks/useAccount";
import { AllActionsEnum } from "../../reducers/actions";
import { identifyUser } from "../../services/identifyUser";
import { RootStore } from "../../stores/app";
import { retrieveQuestionnaire } from "../retrieve-questionnaire/retrieve-questionnaire";

export function InitializeApp({ children }: Readonly<PropsWithChildren<{}>>): JSX.Element {
  const [rootStore, setRootStore] = useAtom(RootStore);
  const abilityRules = useAbility();
  const isLogged = useIsLogged();
  const { accountData } = useAccount();
  const subscriptionTier = useCurrentUserSubscriptionTier();

  useEffect(
    function setInitialUserData() {
      if (accountData) {
        identifyUser(accountData);
        mixpanel.identify(`${accountData?.id}`);
        mixpanel.people.set({
          email: accountData.email,
          name: accountData.name,
          citizenId: accountData.citizen?.id,
          accountId: accountData.id,
          tierName: subscriptionTier.currentUserTier,
          tierFrequency: subscriptionTier.currentUserTierFrequency,
          tierStartDate: subscriptionTier.currentUserTierStartDate,
          tierEndDate: subscriptionTier.currentUserTierEndDate,
        });
      }

      // IMPOSTA IL NOME UTENTE PER USO LOCALE
      const currentName = rootStore.updates?.formValues?.Nome;
      if (accountData?.name && accountData.name !== currentName) {
        setRootStore({ type: AllActionsEnum.SET_CITIZEN_NAME, payload: { name: `${accountData.name?.trim()}` } });
      }
    },
    [accountData, rootStore.updates?.formValues?.Nome]
  );

  useEffect(
    function lastStepForInitializeApp() {
      if (!isLogged || abilityRules.cannot("readOne", "Citizen")) {
        return;
      }

      retrieveQuestionnaire(setRootStore);
    },
    [abilityRules.rules]
  );

  return <>{children}</>;
}
